// Utilidades compartidas de las pantallas a medida que reemplazan al CRUD
// automático. Hablan directo a PostgREST (atajo /rest/<schema>.<tabla>).
// NO es un motor genérico: cada pantalla declara explícitamente sus columnas y
// campos. Esto solo provee las primitivas (igual que features/inventario/shared).
import { apiClient } from '@/lib/api/client';
import i18n from '@/lib/i18n';

export { Modal, Campo, Switch, fieldCls } from '@/features/inventario/shared';

const repr = { headers: { Prefer: 'return=representation' } };

export function makeRest(schema: string) {
  const base = (t: string) => `/rest/${schema}.${t}`;
  return {
    list: async <T,>(t: string, query = ''): Promise<T[]> => (await apiClient.get<T[]>(`${base(t)}${query}`)).data,
    create: async <T,>(t: string, body: unknown): Promise<T> => {
      const rows = (await apiClient.post<T[]>(base(t), body, repr)).data;
      // Con Prefer:return=representation, 0 filas = bloqueado por RLS o sin permisos.
      if (!rows?.length) throw new Error(i18n.t('admin:shared_err_crear'));
      return rows[0];
    },
    update: async <T,>(t: string, id: string, body: unknown): Promise<T> => {
      const rows = (await apiClient.patch<T[]>(`${base(t)}?id=eq.${id}`, body, repr)).data;
      if (!rows?.length) throw new Error(i18n.t('admin:shared_err_editar'));
      return rows[0];
    },
    remove: async (t: string, id: string) => (await apiClient.delete(`${base(t)}?id=eq.${id}`)).data,
  };
}

export const auth = makeRest('autenticacion');
export const fin = makeRest('financiero');

// select nativo reutilizable (con placeholder)
export const SELECT_PLACEHOLDER = '— Selecciona —';

// Niveles de riesgo del asistente del ERP (Ayuda de Sistemas + pantalla de configuración)
export type RiesgoAsistente = 'consulta' | 'operativa' | 'critica';
export const RIESGO_BADGE: Record<RiesgoAsistente, { label: string; cls: string }> = {
  consulta: { label: 'consulta', cls: 'bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300' },
  operativa: { label: 'operativa · confirma', cls: 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300' },
  critica: { label: 'crítica · reforzada', cls: 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300' },
};
